.vc-pindms-section-container {
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: .02em;
    font-family: var(--font-display);
    font-weight: 600;
    flex: 1 1 auto;
    color: var(--channels-default);
    cursor: pointer;
}

.vc-pindms-modal-content {
    display: grid;
    justify-content: center;
    padding: 1rem;
    gap: 1.5rem;
}

.vc-pindms-modal-content [class^="defaultContainer"] {
    display: none;
}

.vc-pindms-collapse-icon {
    width: 16px;
    height: 16px;
    color: var(--interactive-normal);
    transform: rotate(90deg)
}

.vc-pindms-collapsed .vc-pindms-collapse-icon {
    transform: rotate(0deg);
}
